import axios from 'axios';

export async function downloadAndSavePdfFile(url, fileName) {
  const response = await axios.get(url, {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
    },
  });
  const blob = new Blob([response.data], {type: 'application/pdf'});
  saveAs(blob, fileName);
}
